import { createAsyncThunk } from '@reduxjs/toolkit';
import { buildSalesforceParamsQuery } from '../../utils/methods';
import request from '../../modules/Request/request';

export const getActiveUsers = createAsyncThunk(
  'getActiveUsers',
  async (object, { rejectWithValue }) => {
    const { page, accountId, packageId } = object;
    const query = { page, accountId, packageId };
    const finalQuery = buildSalesforceParamsQuery(query, object);
    const response = await request('/active-user', { method: 'GET', query: finalQuery });
    if (response.success) return response.data;
    const error = response.error && response.error.message
      ? response.error.message
      : response.error;
    throw rejectWithValue(error || 'Something went wrong');
  },
);
